import {
    FF_SHYROHEALTH_CUSTOM_THEME,
    FF_CHECKPOINT_CUSTOM_THEME,
    FF_WHITE_LABEL_EXAMPLE_THEME,
} from '@upheal/utils/feature-flags';

export const isShyroHealthCustomTheme =
    import.meta.env.VITE_REACT_APP_CUSTOM_THEME === 'shyrohealth' ||
    FF_SHYROHEALTH_CUSTOM_THEME.on;

export const isCheckpointCustomTheme =
    import.meta.env.VITE_REACT_APP_CUSTOM_THEME === 'checkpoint' ||
    FF_CHECKPOINT_CUSTOM_THEME.on;

export const isWhiteLabelExampleTheme = FF_WHITE_LABEL_EXAMPLE_THEME.on;

export const isWhiteLabelApp =
    isShyroHealthCustomTheme ||
    isCheckpointCustomTheme ||
    isWhiteLabelExampleTheme;

export const isDefaultApp = !isWhiteLabelApp;
export const hasOnlineCall =
    isShyroHealthCustomTheme ||
    isCheckpointCustomTheme ||
    isWhiteLabelExampleTheme;
export const hasAudioRecorder =
    isCheckpointCustomTheme || isWhiteLabelExampleTheme;
